import { render, staticRenderFns } from "./dataImportInfo.vue?vue&type=template&id=28b231a0"
import script from "./dataImportInfo.vue?vue&type=script&lang=js"
export * from "./dataImportInfo.vue?vue&type=script&lang=js"
import style0 from "./dataImportInfo.vue?vue&type=style&index=0&id=28b231a0&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports